import { MoneyUnit } from "@/modules/types/enum";
import moment from "moment";

export const formatUSD = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",

  // These options can be used to round to whole numbers.
  trailingZeroDisplay: "stripIfInteger", // This is probably what most people
  // want. It will only stop printing
  // the fraction when the input
  // amount is a round number (int)
  // already. If that's not what you
  // need, have a look at the options
  // below.
  //minimumFractionDigits: 0, // This suffices for whole numbers, but will
  // print 2500.10 as $2,500.1
  //maximumFractionDigits: 0, // Causes 2500.99 to be printed as $2,501
});

export const formatVND = new Intl.NumberFormat("vi-VN", {
  style: "currency",
  currency: "VND",

  // These options can be used to round to whole numbers.
  trailingZeroDisplay: "stripIfInteger", // This is probably what most people
  // want. It will only stop printing
  // the fraction when the input
  // amount is a round number (int)
  // already. If that's not what you
  // need, have a look at the options
  // below.
  //minimumFractionDigits: 0, // This suffices for whole numbers, but will
  // print 2500.10 as $2,500.1
  //maximumFractionDigits: 0, // Causes 2500.99 to be printed as $2,501
});

export const formatCurrency = (value: number, currency: MoneyUnit) => {
  if (!value) value = 0;
  switch (currency) {
    case MoneyUnit.usd:
      return formatUSD.format(value);
    case MoneyUnit.vnd:
      return formatVND.format(value);
    default:
      return formatVND.format(value);
  }
};

export const diffDate = (d1: number, d2: number): string => {
  const date1 = moment.unix(d1);
  const date2 = moment.unix(d2);
  const diffYear = date2.diff(date1, "years");
  if (diffYear > 0) {
    return `${diffYear} năm trước`;
  }
  const diffMonth = date2.diff(date1, "months");
  if (diffMonth > 0) {
    return `${diffMonth} tháng trước`;
  }
  const diffDay = date2.diff(date1, "days");
  if (diffDay > 0) {
    return `${diffDay} ngày trước`;
  } else {
    return "hôm nay";
  }
};

export const titleCase = (str: string): string => {
  const splitStr = str.toLowerCase().split(" ");
  for (let i = 0; i < splitStr.length; i++) {
    // You do not need to check if i is larger than splitStr length, as your for does that for you
    // Assign it back to the array
    splitStr[i] =
      splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
  }
  // Directly return the joined string
  return splitStr.join(" ");
};
